// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 100px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  z-index: 2000;
  position: relative;
}
.navbar .logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.navbar .links {
  display: flex;
  align-items: center;
}
.navbar .links ul {
  display: flex;
  align-items: center;
  gap: 20px;
}
.navbar .links ul li {
  list-style: none;
  cursor: pointer;
  color: #101928;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.navbar .links ul li a {
  text-decoration: none;
  color: #101928;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.navbar .links ul li a:hover {
  color: var(--color-blue-dark);
}
.navbar .buttons {
  display: flex;
  align-items: center;
  padding-right: 20px;
  gap: 20px;
}
.navbar .buttons .create-an-account {
  background-color: transparent;
  border: 1px solid var(--pmu-primary);
  color: var(--pmu-primary);
  padding: 10px 20px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500px;
}
.navbar .buttons .create-an-account:hover {
  background-color: rgb(229.5, 229.5, 229.5);
}
.navbar .hamburger-menu {
  display: none;
  font-size: 24px;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .navbar {
    padding: 10px 15px;
  }
  .navbar .logo {
    padding-left: 0;
  }
  .navbar .links {
    display: none;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 20px 0;
    z-index: 1000;
  }
  .navbar .links ul {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .navbar .links ul li a {
    font-size: 16px;
  }
  .navbar .links.visible {
    display: flex;
    flex-direction: column;
  }
  .navbar .buttons {
    display: none;
  }
  .navbar .hamburger-menu {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/layout/public/navbar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAN;AAEM;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAR;AAEQ;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAV;AAEU;EACE,6BAAA;AAAZ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AALJ;AAOI;EACE,6BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AALN;AAOM;EACE,0CAAA;AALR;AAUE;EACE,aAAA;EACA,eAAA;EACA,eAAA;AARJ;AAWE;EA5EF;IA6EI,kBAAA;EARF;EAUE;IACE,eAAA;EARJ;EAWE;IACE,aAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,gBAAA;IACA,wCAAA;IACA,eAAA;IACA,aAAA;EATJ;EAWI;IACE,sBAAA;IACA,mBAAA;IACA,SAAA;EATN;EAWM;IACE,eAAA;EATR;EAcE;IACE,aAAA;IACA,sBAAA;EAZJ;EAeE;IACE,aAAA;EAbJ;EAgBE;IACE,cAAA;EAdJ;AACF","sourcesContent":[".navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 100px;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);\n  margin-bottom: 10px;\n  z-index: 2000;\n  position: relative;\n\n  .logo {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  .links {\n    display: flex;\n    align-items: center;\n\n    ul {\n      display: flex;\n      align-items: center;\n      gap: 20px;\n\n      li {\n        list-style: none;\n        cursor: pointer;\n        color: #101928;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n\n        a {\n          text-decoration: none;\n          color: #101928;\n          font-size: 14px;\n          font-weight: 600;\n          line-height: 20px;\n\n          &:hover {\n            color: var(--color-blue-dark);\n          }\n        }\n      }\n    }\n  }\n\n  .buttons {\n    display: flex;\n    align-items: center;\n    padding-right: 20px;\n    gap: 20px;\n\n    .create-an-account {\n      background-color: transparent;\n      border: 1px solid var(--pmu-primary);\n      color: var(--pmu-primary);\n      padding: 10px 20px;\n      border-radius: 12px;\n      cursor: pointer;\n      font-size: 14px;\n      font-weight: 500px;\n\n      &:hover {\n        background-color: darken($color: #fff, $amount: 10%);\n      }\n    }\n  }\n\n  .hamburger-menu {\n    display: none;\n    font-size: 24px;\n    cursor: pointer;\n  }\n\n  @media screen and (max-width: 768px) {\n    padding: 10px 15px;\n\n    .logo {\n      padding-left: 0;\n    }\n\n    .links {\n      display: none;\n      position: absolute;\n      top: 60px;\n      left: 0;\n      width: 100%;\n      background: #fff;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      padding: 20px 0;\n      z-index: 1000;\n\n      ul {\n        flex-direction: column;\n        align-items: center;\n        gap: 20px;\n\n        li a {\n          font-size: 16px;\n        }\n      }\n    }\n\n    .links.visible {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .buttons {\n      display: none;\n    }\n\n    .hamburger-menu {\n      display: block;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
